module.exports = __webpack_public_path__ + "static/media/summary.c2213a72.png";